module.exports = __webpack_public_path__ + "img/home-background.fe796949.png";